import update, {CustomCommands, Spec} from 'immutability-helper';

export default function SafeUpdate<T, C extends CustomCommands<object> = never>(object: T, $spec: Spec<T, C>) {
    return update(object, $spec);
}
